module.exports = __webpack_public_path__ + "ab69a396b0f8bf10a2790eaaad53296a.MP3";